module.exports = __webpack_public_path__ + "static/media/svg14.6050da9d.svg";